import { useState } from "react";
import { Select } from "@normasteaching/norma-ui";
import { PrimaryButton } from "../UI/PrimaryButton.tsx";
import { TextButton } from "../UI/TextButton.tsx";
import { isDefined } from "../isDefined.ts";

type WeekSlot = {
  dayOfWeek: number;
  startTime: string;
  endTime: string;
};

const DAYS_OF_WEEK = [
  { id: "1", name: "Lunedì" },
  { id: "2", name: "Martedì" },
  { id: "3", name: "Mercoledì" },
  { id: "4", name: "Giovedì" },
  { id: "5", name: "Venerdì" },
  { id: "6", name: "Sabato" },
  { id: "0", name: "Domenica" },
];

const HOURS = Array.from({ length: 16 }, (_, i) => {
  const hour = i + 7;
  return { id: hour.toString(), name: `${hour}:00` };
});

export function WeekSlotInput({
  value,
  onChange,
  errorMessage,
}: {
  value: WeekSlot[];
  onChange: (value: WeekSlot[]) => void;
  errorMessage?: string;
}) {
  const [selectedDay, setSelectedDay] = useState<string | null>();
  const [selectedStartHour, setSelectedStartHour] = useState<string | null>();

  const addSlot = () => {
    if (!isDefined(selectedDay) || !isDefined(selectedStartHour)) return;

    const startTime = `${selectedStartHour.toString().padStart(2, "0")}:00:00`;
    const endTime = `${(parseInt(selectedStartHour) + 1).toString().padStart(2, "0")}:00:00`;

    const newSlot: WeekSlot = {
      dayOfWeek: parseInt(selectedDay),
      startTime,
      endTime,
    };

    onChange([...value, newSlot]);
    setSelectedDay(undefined);
    setSelectedStartHour(undefined);
  };

  const removeSlot = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  const getDayName = (dayOfWeek: string) => {
    return DAYS_OF_WEEK.find((d) => d.id === dayOfWeek)?.name ?? "";
  };

  return (
    <div className="space-y-3">
      <div className="flex space-x-2">
        <div className="flex-1">
          <Select
            placeholder="Giorno della settimana"
            options={DAYS_OF_WEEK}
            value={selectedDay ?? undefined}
            onChange={setSelectedDay}
          />
        </div>
        <div className="flex-1">
          <Select
            placeholder="Ora di inizio"
            options={HOURS}
            value={selectedStartHour ?? undefined}
            onChange={setSelectedStartHour}
          />
        </div>
        <div>
          <PrimaryButton
            label="Aggiungi"
            onClick={addSlot}
            disabled={
              selectedDay === undefined || selectedStartHour === undefined
            }
          />
        </div>
      </div>

      {errorMessage && <p className="text-sm text-red-600">{errorMessage}</p>}

      <div className="space-y-2">
        {value.map((slot, index) => {
          const startHour = slot.startTime.split(":")[0];
          const endHour = slot.endTime.split(":")[0];
          return (
            <div
              key={index}
              className="flex items-center justify-between p-3 bg-gray-50 rounded-md"
            >
              <span>
                {getDayName(`${slot.dayOfWeek}`)} dalle {startHour}:00 alle{" "}
                {endHour}
                :00
              </span>
              <TextButton label="Rimuovi" onClick={() => removeSlot(index)} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
